module.exports = __webpack_public_path__ + "static/media/blaine-miss.8925c576.wav";